import { useTranslations } from '@/lib/i18n';
import { lazy } from '@loadable/component';
import type { ComponentType } from 'react';
import React, { Suspense } from 'react';
import LoadingBox from './loading-box';

interface Props {
  loader(): Promise<{ default: ComponentType<unknown> }>;
  loading?: ComponentType;
}

const Loadable = ({ loader, loading }: Props) => {
  const LazyComponent = lazy(loader);

  const Load = loading || LoadingBox;

  const t = useTranslations();

  const InnerComponent = () => {
    return (
      <Suspense fallback={<Load>{t('common.loading')}...</Load>}>
        <LazyComponent />
      </Suspense>
    );
  };

  return React.memo(InnerComponent);
};

export default Loadable;
